import React, { Component } from "react";
import PropTypes from "prop-types";

import LineSeries from "./LineSeries";
import StraightLine from "./StraightLine";

class DIDISeries extends Component {
  constructor(props) {
    super(props);
    this.yAccessorLong = this.yAccessorLong.bind(this);
    this.yAccessorShort = this.yAccessorShort.bind(this);
  }

  yAccessorLong(d) {
    const { yAccessor } = this.props;
    const node = yAccessor ? yAccessor(d) : undefined;
    return node && Number.isFinite(node.long) ? node.long : undefined;
  }

  yAccessorShort(d) {
    const { yAccessor } = this.props;
    const node = yAccessor ? yAccessor(d) : undefined;
    return node && Number.isFinite(node.short) ? node.short : undefined;
  }

  render() {
    const {
      className,
      clip,
      longStroke,
      shortStroke,
      centerStroke,
      onContextMenu,
      onDoubleClick,
      highlightOnHover,
    } = this.props;

    return (
      <g className={className}>
        <LineSeries
          className="react-stockcharts-didi-long"
          clip={clip}
          yAccessor={this.yAccessorLong}
          stroke={
            typeof longStroke === "string" ? { color: longStroke } : longStroke
          }
          connectNulls
          highlightOnHover={highlightOnHover}
          onContextMenu={onContextMenu}
          onDoubleClick={onDoubleClick}
        />
        <LineSeries
          className="react-stockcharts-didi-short"
          clip={clip}
          yAccessor={this.yAccessorShort}
          stroke={
            typeof shortStroke === "string"
              ? { color: shortStroke }
              : shortStroke
          }
          connectNulls
          highlightOnHover={highlightOnHover}
          onContextMenu={onContextMenu}
          onDoubleClick={onDoubleClick}
        />
        {(() => {
          const stroke =
            typeof centerStroke === "string"
              ? { color: centerStroke }
              : centerStroke || {};
          return (
            <StraightLine
              className="react-stockcharts-didi-center"
              stroke={{
                color: stroke.color ?? "#0000ff",
                opacity: stroke.opacity ?? 1,
                width: stroke.width ?? 1,
                dash: stroke.dash ?? "Dot",
              }}
              yValue={0}
              highlightOnHover={highlightOnHover}
              onContextMenu={onContextMenu}
              onDoubleClick={onDoubleClick}
            />
          );
        })()}
      </g>
    );
  }
}

DIDISeries.propTypes = {
  className: PropTypes.string,
  clip: PropTypes.bool,
  yAccessor: PropTypes.func.isRequired,
  longStroke: PropTypes.oneOfType([
    PropTypes.shape({
      color: PropTypes.string,
      width: PropTypes.number,
      dash: PropTypes.string,
      opacity: PropTypes.number,
    }),
    PropTypes.string,
  ]),
  shortStroke: PropTypes.oneOfType([
    PropTypes.shape({
      color: PropTypes.string,
      width: PropTypes.number,
      dash: PropTypes.string,
      opacity: PropTypes.number,
    }),
    PropTypes.string,
  ]),
  centerStroke: PropTypes.oneOfType([
    PropTypes.shape({
      color: PropTypes.string,
      width: PropTypes.number,
      dash: PropTypes.string,
      opacity: PropTypes.number,
    }),
    PropTypes.string,
  ]),
  onContextMenu: PropTypes.func,
  onDoubleClick: PropTypes.func,
  highlightOnHover: PropTypes.bool,
};

DIDISeries.defaultProps = {
  className: "react-stockcharts-didi-series",
  clip: true,
  highlightOnHover: true,
  longStroke: { color: "#ff0000", width: 1, dash: "Solid", opacity: 1 },
  shortStroke: { color: "#00ff00", width: 1, dash: "Solid", opacity: 1 },
  centerStroke: { color: "#0000ff", width: 1, dash: "Dot", opacity: 1 },
};

export default DIDISeries;
